import { LoanReviewChecklistService } from '@/modules/global-settings/loan-origination/services/loan-policies/loan-review-checklist.service';
import { make } from 'vuex-pathify';

// Instantiate the service
const checklistService = new LoanReviewChecklistService();
// Define the state
export const state = {
  checklists: []
};
// Define the mutations
export const mutations = { ...make.mutations(state) };
// Define the actions
export const actions = {
  /**
   * Fetch all checklists
   * @async
   * @param {object} context - The store context
   * @param {object} payload - The payload object
   * @returns {number} - The status code
   * @private This will update the state with the fetched checklists
   */
  async fetchChecklists({ commit }) {
    const result = await checklistService.fetchChecklists();
    if (result.status == 200) {
      commit('SET_CHECKLISTS', result.data);
    }
    return result.status;
  },

  /**
   * Update a checklist
   * @async
   * @param {object} context - The store context
   * @param {object} payload - The payload object
   * @param {string} payload.id - The checklist id
   * @param {object} payload.updates - The updates to be made
   * @returns {number} - The status code
   * @private This will refetch the checklists
   */
  async updateChecklist({ dispatch }, { id, updates }) {
    const result = await checklistService.updateChecklist(id, updates);
    if (result.status == 200) {
      dispatch('fetchChecklists');
    }
    return result.status;
  },

  /**
   * Create a checklist
   * @async
   * @param {object} context - The store context
   * @param {object} payload - The payload object
   * @returns {number} - The status code
   * @private This will refetch the checklists
   */
  async createChecklist({ dispatch }, newChecklist) {
    const result = await checklistService.createChecklist(newChecklist);
    if (result.status == 201) {
      dispatch('fetchChecklists');
    }
    return result.status;
  },

  /**
   * Delete a checklist
   * @async
   * @param {object} context - The store context
   * @param {number | string} checklistId - The checklist id
   * @returns {number} - The status code
   * @private This will refetch the checklists
   */
  async deleteChecklist({ dispatch }, checklistId) {
    const result = await checklistService.deleteChecklist(checklistId);
    if (result.status == 200) {
      dispatch('fetchChecklists');
    }
    return result.status;
  }
};
// Define the getters
export const getters = { ...make.getters(state) };
